module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBold.21edc00b.eot";